import { render } from "./TunnelDetailView.vue?vue&type=template&id=ba8917e6"
import script from "./TunnelDetailView.vue?vue&type=script&lang=js"
export * from "./TunnelDetailView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__